// ★ VJ — a DATA DE RETORNO das colunas de "não" é uma TAREFA (o "próximo
// contato" que já existe), montada no MESMO lote da mudança de etapa. Puro:
// aqui só se decide o QUE a tarefa diz; quem grava é o serviço.
import { cadenciaParaLead, proximaData } from '@/leads/cadencia';

/** Tipo da tarefa por coluna: ligação da SDR em Não agendou; retorno do negociador em Não fechou. */
export const TIPO_TAREFA_RETORNO = { nao_agendou: 'ligacao', nao_fechou: 'retorno',
  // VQ-3: cancelar a última consulta pela agenda move para cá e pede retorno.
  nao_compareceu: 'ligacao',
};

/** `origem` da tarefa (valor novo de um campo que já existia: 'manual' | 'comparecimento'). */
export const ORIGEM_TAREFA_RETORNO = 'mudanca_etapa';

const UM_DIA = 86_400_000;

/**
 * Valor PADRÃO do campo "Retorno em": a cadência da clínica para a etapa de
 * destino (pós-comparecimento em Não fechou; follow-up em Não agendou), a
 * partir das tentativas já feitas. Cadência esgotada → amanhã, mesma hora. A
 * pessoa edita; o padrão só poupa digitação.
 */
export function dataDeRetornoPadrao(lead, etapa, config = null, agora = new Date()) {
  const cadencia = cadenciaParaLead({ ...lead, etapa }, config);
  return proximaData(lead?.tentativasContato ?? 0, cadencia, agora) ?? new Date(agora.getTime() + UM_DIA);
}

/**
 * Os dados da tarefa de retorno (entrada de `montarTarefa`).
 * Responsável: em Não fechou, o negociador (o escolhido agora, senão o do lead);
 * em Não agendou, o SDR do lead. Sem nenhum, `montarTarefa` cai em quem grava.
 */
export function dadosDaTarefaDeRetorno(lead, { etapa, motivoRotulo = '', retornoEm, negociadorId, negociadorNome } = {}) {
  const tipo = TIPO_TAREFA_RETORNO[etapa];
  if (!tipo) throw new Error(`Etapa sem tarefa de retorno: ${etapa}`);
  const paraNegociador = etapa === 'nao_fechou';
  const responsavelId = paraNegociador ? (negociadorId || lead?.negociadorId || lead?.sdrId || '') : (lead?.sdrId ?? '');
  const responsavelNome = paraNegociador
    ? (negociadorId ? (negociadorNome ?? '') : (lead?.negociadorNome || lead?.sdrNome || ''))
    : (lead?.sdrNome ?? '');
  return {
    titulo: `Retorno — ${String(motivoRotulo ?? '').trim() || 'sem motivo'}`,
    tipo,
    origem: ORIGEM_TAREFA_RETORNO,
    dataHora: retornoEm,
    responsavelId,
    responsavelNome,
    leadEtapa: etapa,
  };
}
